import { useSelector } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import Storage from "../utills/AsyncStorage";
import styles from "./layoutstyle.module.css";
import { Button, Result } from "antd";
import { roles } from "../config/roles";
// import AuthFromQuery from "./AuthFromQuery";
export const HomeLayout = () => {
  const isLoginState = useSelector((state) => state.AuthReducer.isLogin);
  const user = Storage.getUser("@user");
  const role = Storage.getERole("@role");
  console.log("staning on home layout", isLoginState);

  const navigate = useNavigate();
  const forCustomer = role === roles.user || user?.total_assets <= 0;

  function getRedirectDealer(user) {
    const { is_profile_completed, is_approved } = user;
    if (is_profile_completed && is_approved) return "/dashboard";
    if (!is_profile_completed && !is_approved) return "/accountSetup";
    if (is_profile_completed && !is_approved) return "/verificationProcess";
  }

  if (isLoginState) {
    return (
      <Navigate
        to={
          role === roles.dealership
            ? getRedirectDealer(user)
            : forCustomer
              ? "/userDashboard"
              : role === roles.company
                ? "/company-dashboard"
                : "/"
        }
      />
    );
  }

  return (
    <div className={styles.publiclayoutContainer}>
      {/* <AuthFromQuery /> */}
      <Outlet />
    </div>
  );
};

export const RolesLayout = ({ roles }) => {
  const role = Storage.getERole("@role");
  const navigate = useNavigate();
  if (!roles?.includes(role)) {
    return (
      <Result
        style={{ width: "100%", padding: "0px !important" }}
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={
          <Button type="primary" onClick={() => navigate(-1)}>
            Go Back
          </Button>
        }
      />
    );
  }
  return (
    <div>
      <Outlet />
    </div>
  );
};
